<template>
  <div class="detail-view">
    <b-container>
      <booking-engine @search="() => { this.$router.push({ name: 'results' }) }"/>
      <section class="section section--loader" v-if="searching">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section class="section" v-else>
        <detail-content-block
          :details="details"
          :availabilities="availabilities"
          :availability="availability.toString()"
        />
      </section>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { service_handler } from '@src/services'
import { custom_event } from '@utilities'
import { get_live_price_no_tax } from '@bookingv3/utilities'
import DetailContentBlock from '@bookingv3/components/views/content-blocks/detail.vue'

export default {
  name: 'detail-view',

  components: {
    'detail-content-block': DetailContentBlock
  },

  props: {
  },

  data() {
    return {
      details: {},
      availabilities: {},
    }
  },

  computed: {
    ...mapState({
      // stato globale
      searching: state => state.searching,
      occupancy: state => state.occupancy,
      availability: state => state.availability,

      // stato del modulo livebkv3
      checkin: state => state.livebkv3.checkin,
      checkout: state => state.livebkv3.checkout,
      rooms_selection: state => state.livebkv3.rooms_selection,

      selected_hotel: state => state.livebkv3.selected_hotel,
    }),

    // Associa i prodotti alle rispettive camere
    parse_rooms() {
      return this.details.rooms.map(room => (
        {
          ...room,
          products: this.availabilities.products.filter(product => product.room === room.id)
        }
      )).filter(room => room.products.length > 0)
    },
  },

  created() {
  },

  mounted() {
    this.price()
  },

  methods: {

    // Chiamata alla details e creazione del modello dei prodotti (create_model_products)
    price() {
      let params = {
        checkin: this.checkin,
        checkout: this.checkout,
        occupancy: this.occupancy,
        accommodation: this.selected_hotel.id /*(id hotel sandbox: 10507360)*/
      }

      this.$store.commit('searching', true)

      service_handler(
        'details',
        params
      ).then(
        (success) => {
          this.availabilities = success.data.availabilities
          this.details = success.data.details

          this.details.rooms = this.parse_rooms

          let solution = {
            hotel_name: `${this.details.name.it}`,
            hotel_address: `${this.details.location.address.it}, ${this.details.location.postal_code} ${this.details.location.city_name}`,
            occupancy: this.occupancy,

            accommodation: {
              hotel_id: this.details.id,
              checkin: this.checkin,
              checkout: this.checkout,
              multiroom_assignment: false,
            }
          }

          this.create_model_products()

          this.$store.commit('searching', false)
          this.$store.commit('livebkv3/selected_solution', solution)

          custom_event({
            event: 'view_item',
            ecommerce: {
              currency: "EUR",
              items: this.parseGa4EcommerceItems(success.data.details, success.data.availabilities),
              transaction_id: "",
              affiliation: "",
              value: 0, // Sum of (price * quantity) for all items.
              tax: 0,
              shipping: 0,
              coupon: "",
            }
          });

        },
      )
    },
    parseGa4EcommerceItems(details, availabilities){
      // results = filtered

      const items = [];

      let hotelName = details.name.it || Object.values(details.name)[0]

      availabilities.products.forEach(block => {

        items.push({
          "item_id": details.id + "-" + block.id,
          "item_name": hotelName + " - "+ block.room,
          "item_brand": "",
          "price": get_live_price_no_tax(block.price),
          "item_category": "",
        });

      });

      return items;

    },

    // Crea il modello predefinito di prezzi e quantità dei prodotti, usato dalle select per scegliere le quantità.
    create_model_products() {
      const create_default_products = () => ({
        price: {qty: 0, base: 0, book: 0, total: 0, live_price: 0, live_price_no_tax: 0, extra_charges: {}}
      })

      const update_model_products = this.details.rooms.map(room =>
        room.products.map(create_default_products)
      )

      this.$store.commit('livebkv3/rooms_selection', {
        ...this.rooms_selection,
        model_products: update_model_products,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
</style>